module.exports = __webpack_public_path__ + "2c68559299c21b64863c2af46956ae80.png";